export default {

  menu_header_home: "Home",
  menu_header_projects: "Projects",
  menu_header_about: "About",
  menu_header_contact: "Contact",
  menu_header_for_sale: "For Sale",


  banner_header: "Habitat 3.0 Life Re-Imagined",
  banner_sub: "Redefining the Future of Residential Development in Mexico and Beyond",
  banner_button: "Explore our work",

  projects_title: "Our Projects",
  services_title: "Our Services",


  services_bienes: "Whether buying, selling, or investing, we help you navigate the real estate market with expert guidance, connecting you with the best opportunities in the Yucatán Peninsula. Contact Us!",
  services_building: "Whether revamping your current home or starting from scratch, our expert team brings your vision to life. From modern upgrades to full-scale renovations and custom homes, we prioritize health, sustainability, comfort, and functionality in every project. Contact us!",
  services_design: "From private homes to full-scale communities and commercial projects, we specialize in green building, functional design, and cutting-edge technology to create healthy, smart and energy-efficient spaces tailored to your needs. Contact us!",
  services_maquirent: "Need the right tools for your construction or renovation project? Maquirent offers a wide selection of high-quality, professional-grade small construction tools for rent, helping homeowners, builders, and contractors get the job done efficiently. Contact Us!",

  services_bienes_title: "Real Estate & Property Solutions",
  services_building_title: "Renovations & Custom Builds",
  services_design_title: "Sustainable Design & Construction",
  services_rent_title: "Maquirent–Small Construction Tool Rental",

  about_us: "About us",
  about_us_description: "With 25 years of construction experience in Yucatan, Mexico, our team includes a LEED and WELL AP certified professional, a civil engineer, and a product and communications design expert. Together, we ensure the development of sustainable, innovative, and well-connected projects.",

}
